package org.example.willfreightnew.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.willfreightnew.HeadlineTextStyle
import org.example.willfreightnew.components.BackToTopButton
import org.example.willfreightnew.components.layouts.PageLayoutData
import org.example.willfreightnew.components.models.Section
import org.example.willfreightnew.components.sections.AboutSection
import org.example.willfreightnew.components.sections.ContactSection
import org.example.willfreightnew.components.sections.ServiceSection
import org.example.willfreightnew.components.util.Constants.FONT_FAMILY
import org.example.willfreightnew.toSitePalette
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P

// Container that has a tagline and grid on desktop, and just the tagline on mobile
val HeroContainerStyle = CssStyle {
    base { Modifier.fillMaxWidth().gap(2.cssRem) }
    Breakpoint.MD { Modifier.margin { top(0.1.cssRem) } }
}

// data class CarouselImage(
//    val src: String,
//    val caption: String
// )

@InitRoute
fun initHomePage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Home"))
}

@OptIn(DelicateApi::class)
@Composable
fun MainImage() {
    var breakpoint = rememberBreakpoint()
    var headerSize = if(breakpoint >= Breakpoint.MD) {75}  else if (breakpoint >= Breakpoint.SM) {45} else {30}
    var subtitleSize = if(breakpoint >= Breakpoint.MD) {50} else if (breakpoint >= Breakpoint.SM) {35} else {20}


    Box(Modifier
        .height(if(breakpoint >= Breakpoint.MD) {700.px} else {500.px})
        .margin(top = (-64).px)
        .width(if(breakpoint >= Breakpoint.MD) 1000.percent else 150.percent)
        .overflow(Overflow.Hidden)
        .backgroundColor(Colors.Black)
        .zIndex(0),
        contentAlignment = Alignment.Center
        )
    {
        SpanText("WHERE THERE'S A WILL", Modifier.fontFamily(FONT_FAMILY).zIndex(1).textShadow(0.px,0.px, 10.px, Colors.Black)
            .fontSize(headerSize.px).color(Colors.White).fontWeight(FontWeight.Bold).fontStyle(FontStyle.Italic).margin(bottom = headerSize.px)
        )
        Br()
        SpanText("THERE'S A WAY", Modifier.fontFamily(FONT_FAMILY).zIndex(1).textShadow(0.px,0.px, 10.px, Colors.Black)
            .fontSize(subtitleSize.px).color(Colors.White).fontWeight(FontWeight.Light).fontStyle(FontStyle.Italic).margin(top = subtitleSize.px)
        )

        Image(
            "/wf_image1.webp",
            "Scenic image of Belfast's docks",
            Modifier
                .fillMaxWidth(if(breakpoint >= Breakpoint.MD) 40.percent else 400.percent)
                .objectFit(ObjectFit.Cover)
                .opacity(40.percent)
        )

    }
}

@Composable
fun MainText(breakpoint: Breakpoint) {
    Column(Modifier.fillMaxWidth(if (breakpoint >= Breakpoint.MD) 80.percent else 90.percent)) {
        Div(HeadlineTextStyle.toAttrs()) {

        }

        Button (attrs = Modifier
            .margin { top(2.cssRem) }
            .height(5.cssRem)
            .width(8.cssRem)
            .border(width = 5.px)
            .borderRadius(10.px)
            .backgroundColor(ColorMode.current.toSitePalette().brand.accent)
            .color(Colors.White)
            .toAttrs()
        ) {
          Link(modifier = Modifier
              .color(Colors.White)
              .textDecorationLine(TextDecorationLine.None)
              .fontSize(1.2.cssRem),
              text = "Let's get moving",
              path = Section.Contact.path
          )
        }

        P() {

        }
    }
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun HomePage() {
    Box(modifier = Modifier.fillMaxSize()) {
        Column(
            Modifier
                .fillMaxWidth(),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            MainImage()
            AboutSection()
            ServiceSection()
            ContactSection()
        }
    }
}

// ***Maintext Paragraph experiment***
//
//        P(
//            attrs = Modifier
//                .margin(topBottom = 0.px)
//                .fontFamily(Constants.FONT_FAMILY)
//                .fontSize(45.px)
//                .fontWeight(FontWeight.Bold)
//                .fontStyle(FontStyle.Italic)
//                .color(ColorMode.current.toSitePalette().brand.primary)
//                .toAttrs()
//        ) {
//            SpanText("When there's a ")
//        }
//
//        P(
//            attrs = Modifier
//                .margin(topBottom = 0.px)
//                .fontFamily(Constants.FONT_FAMILY)
//                .fontSize(45.px)
//                .fontWeight(FontWeight.Bold)
//                .fontStyle(FontStyle.Italic)
//                .color(ColorMode.current.toSitePalette().brand.accent)
//                .toAttrs()
//        ) {
//            Text("Will")
//        }

// ***Carousel experiment 1***
//
// @Composable
//fun imgCarousel(images: List<String>) {
//    Div(
//        attrs = {
//            style {
//                scrollBehavior(ScrollBehavior.Smooth)
//            }
//        },
//    )
//
//    Row(
//        modifier = Modifier
//            .padding(left = 16.px)
//    ) {
//        images.forEach { imageUrl ->
//            Image(
//                src = imageUrl.toString(),
//                modifier = Modifier
//                    .alignSelf(AlignSelf.Center)
//                    .width(50.cssRem)
//                    .height(30.cssRem)
//                    .margin(left = 1.cssRem, right = 1.cssRem)
//            )
//        }
//    }
//}
// Carousel experiment 2
//
//@Composable
//fun imgCarousel(images:List<CarouselImage>) {
//    var currentIndex by remember { mutableStateOf(0) }
//
//    LaunchedEffect(Unit) {
//        while (true) {
//            delay(10000)
//            currentIndex = (currentIndex + 1) % images.size
//        }
//    }
//
//    // Image in carousel
//    Div {
//        Image(
//            src = images[currentIndex].src,
//            modifier = Modifier
//                .alignSelf(AlignSelf.Center)
//                .width(50.cssRem)
//                .height(30.cssRem)
//                .margin(left = 1.cssRem, right = 1.cssRem)
//                .overflow { Overflow.Hidden }
//        )
//    }
//
//    // Image captions
//    Div(
//        attrs = {
//            style {
//                Modifier
//                    .color(Color.rgb(5,5,5))
//                    .padding(12.px)
//                    .textAlign(TextAlign.Center)
//            }
//        }
//    ) {
//        Text(images[currentIndex].caption)
//    }
//
//    // Prev
//    Button(
//        attrs = {
//            style {
//                Modifier
//                    .position(Position.Absolute)
//                    .left(10.px)
//                    .top(5.cssRem)
//                    .transform { translateX(50.cssRem) }
//            }
//                onClick {
//                currentIndex = (currentIndex - 1 + images.size) % images.size
//            }
//        }
//    ) {
//        Text("←")
//    }
//
//    // Next
//    Button(
//        attrs = {
//            style {
//                Modifier
//                    .position(Position.Absolute)
//                    .right(10.cssRem)
//                    .top(50.cssRem)
//                    .animation(
//
//                    )
//            }
//            onClick {
//                currentIndex = (currentIndex + 1) % images.size
//            }
//        }
//    ) {
//        Text("→")
//    }
//}